import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PageService } from '../../services/page.service';
import Swal from 'sweetalert2';
import { element } from 'protractor';

@Component({
  selector: 'app-contacto-modal',
  templateUrl: './contacto-modal.component.html',
  styleUrls: ['./contacto-modal.component.css'],
})
export class ContactoModalComponent implements OnInit {
  contactoForm: FormGroup;
  contacto: any;
  accionesList: any[];
  cargosList: any[];
  acciones: any;
  codigoColaborador: any;
  accionesByContacto: any[] = [];
  formData: FormData;
  rojo: boolean = false;
  editado: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ContactoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: PageService,
    private router: Router
  ) {
    this.codigoColaborador = parseInt(
      sessionStorage.getItem('codigoColaborador')
    );
  }

  ngOnInit(): void {
    console.log('Entro en el contacto modal component');
    console.log('DATA', this.data);
    this.service.getAcciones().subscribe((res) => {
      console.log('ACCIONES', res);
      this.accionesList = res;
    });
    if (this.data.tipo === 'Editar') {
      const codigo = this.data.contacto.id;
      this.service.getAccionesContacto(codigo).subscribe((res) => {
        console.log('Acciones del contacto:', res);
        res.forEach((accion) => {
          this.accionesByContacto.push(accion[0]);
        });
        this.contactoForm.get('acciones').setValue(this.accionesByContacto);
        console.log('Acciones seleccionadas:', this.accionesByContacto);
      });
    }
    this.cargosList = this.data.cargosList;
    console.log(this.cargosList);
    this.contacto = {};
    if (this.data && this.data.contacto) {
      const contacto = this.data.contacto;
      this.contactoForm = new FormGroup({
        nombre: new FormControl(contacto.nombreContacto, Validators.required),
        apellido1: new FormControl(contacto.apellido1Contacto),
        apellido2: new FormControl(contacto.apellido2Contacto),
        email: new FormControl(contacto.correoContacto, [
          Validators.required,
          Validators.pattern(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ),
        ]),
        telefono: new FormControl(contacto.telefonoContacto),
        cargo: new FormControl(contacto.cargoContacto),
        acciones: new FormControl(contacto.acciones),
        idColaborador: new FormControl(contacto.idColaborador),
      });

      this.contacto = {
        nombre: contacto.nombreContacto,
        apellido1: contacto.apellido1Contacto,
        apellido2: contacto.apellido2Contacto,
        email: contacto.correoContacto,
        telefono: contacto.telefonoContacto,
        cargo: contacto.cargoContacto,
        acciones: contacto.acciones,
        idColaborador: contacto.idColaborador,
      };
    } else {
      this.contactoForm = new FormGroup({
        nombre: new FormControl('', Validators.required),
        apellido1: new FormControl(''),
        apellido2: new FormControl(''),
        email: new FormControl('', [
          Validators.required,
          Validators.minLength(5),
          Validators.pattern(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ),
        ]),
        telefono: new FormControl(''),
        cargo: new FormControl(''),
        acciones: new FormControl([], Validators.required),
        idColaborador: new FormControl(this.codigoColaborador),
      });
    }
    this.contactoForm.valueChanges.subscribe((value) => {
      this.contacto = { ...this.contacto, ...value };
    });
    console.log(this.contactoForm);
  }

  get emailNoValidoC(): any {
    return (
      this.contactoForm.get('email').invalid &&
      this.contactoForm.get('email').touched
    );
  }

  seleccionChange(accionId: number) {
    const accionesControl = this.contactoForm.get('acciones');
    if (accionesControl.value.includes(accionId)) {
      const newValue = accionesControl.value.filter(
        (id: number) => id !== accionId
      );
      accionesControl.patchValue(newValue);
      console.log(accionesControl.value);
      if (accionesControl.value.length === 0) {
        this.rojo = true;
      }
    } else {
      this.rojo = false;
      this.editado = true;
      const newValue = [...accionesControl.value, accionId];
      accionesControl.patchValue(newValue);
    }
  }

  comprobarAcciones(): boolean {
    const accionesControl = this.contactoForm.get('acciones');
    console.log(accionesControl);
    if (accionesControl.value.length === 0) {
      return false;
    } else {
      return true;
    }
  }

  isAccionSelected(accionId: number): boolean {
    const accionesControl = this.contactoForm.get('acciones');
    return (
      accionesControl &&
      accionesControl.value &&
      accionesControl.value.includes(accionId)
    );
  }

  guardarContacto() {
    if (!this.editado) {
      this.rojo = true;
    }
    this.contactoForm.get('nombre').setValidators([Validators.required]);
    this.contactoForm.get('acciones').setValidators([Validators.required]);
    this.contactoForm.get('nombre').updateValueAndValidity();
    this.contactoForm.get('acciones').updateValueAndValidity();
    if (this.contactoForm.valid) {
      this.formData = new FormData();
      if (this.data.tipo === 'Crear') {
        console.log(this.contactoForm.value.acciones);
        const accionesSeleccionadas = this.contactoForm.value.acciones;
        const accionesJSON = {};

        if (Array.isArray(accionesSeleccionadas)) {
          accionesSeleccionadas.forEach((accionId, index) => {
            accionesJSON[index + 1] = accionId;
          });
        }

        console.log(this.contactoForm);

        const nuevoContacto = {
          nombre: this.contactoForm.value.nombre,
          apellido1: this.contactoForm.value.apellido1 || '',
          apellido2: this.contactoForm.value.apellido2 || '',
          email: this.contactoForm.value.email,
          telefono: this.contactoForm.value.telefono || '',
          cargo: this.contactoForm.value.cargo || '',
          idColaborador: this.contactoForm.value.idColaborador,
          acciones: JSON.stringify(accionesJSON),
        };
        console.log(nuevoContacto);

        Object.keys(nuevoContacto).forEach((key) => {
          if (nuevoContacto[key] !== null && nuevoContacto[key] !== undefined) {
            this.formData.append(key, nuevoContacto[key]);
          }
        });

        this.service.addContacto(this.formData).subscribe((res) => {
          console.log(res);
          console.log('Contacto guardado:', nuevoContacto);
          this.router.navigate(['page']);
          this.dialogRef.close(nuevoContacto);
        });
      } else if (this.data.tipo === 'Editar') {
        console.log(this.contactoForm.value.acciones);
        const idContacto = this.data.contacto.id;

        const accionesSeleccionadas = this.contactoForm.value.acciones;
        const accionesJSON = {};

        if (Array.isArray(accionesSeleccionadas)) {
          accionesSeleccionadas.forEach((accionId, index) => {
            accionesJSON[index + 1] = accionId;
          });
        }

        const contactoActualizado = {
          idcontacto: idContacto,
          nombre: this.contactoForm.value.nombre,
          apellido1: this.contactoForm.value.apellido1 || '',
          apellido2: this.contactoForm.value.apellido2 || '',
          email: this.contactoForm.value.email,
          telefono: this.contactoForm.value.telefono || '',
          cargo: this.contactoForm.value.cargo || '',
          idColaborador: this.contactoForm.value.idColaborador,
          acciones: JSON.stringify(accionesJSON),
        };

        console.log(contactoActualizado);

        Object.keys(contactoActualizado).forEach((key) => {
          if (
            contactoActualizado[key] !== null &&
            contactoActualizado[key] !== undefined
          ) {
            this.formData.append(key, contactoActualizado[key]);
          }
        });

        this.service.updateContacto(this.formData).subscribe((res) => {
          console.log(res);
          console.log('Contacto actualizado:', contactoActualizado);
          this.router.navigate(['page']);
          this.dialogRef.close(contactoActualizado);
        });
      }
    }
  }

  borrarContacto() {
    Swal.fire({
      title:
        '<p style="font-size: 20px">¿Está seguro de que quiere eliminarlo?</p>',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#5A1727',
      confirmButtonText: '<span style="font-size: 16px;">Eliminar</span>',
      cancelButtonText: '<span style="font-size: 16px;">Cancelar</span>',
    }).then((result) => {
      if (result.isConfirmed) {
        this.formData = new FormData();
        this.formData.append('idcontacto', this.data.contacto.id);
        this.service.deleteContacto(this.formData).subscribe((res) => {
          console.log(res);
          Swal.fire('', res, 'success');
          this.router.navigate(['page']);
          this.dialogRef.close();
        });
      }
    });
  }

  enviarCorreoPrueba() {
    this.contactoForm.get('nombre').clearValidators();
    this.contactoForm.get('acciones').clearValidators();
    this.contactoForm.get('nombre').updateValueAndValidity();
    this.contactoForm.get('acciones').updateValueAndValidity();
    if (this.contactoForm.get('email').valid) {
      this.service.sendTestEmail(this.contactoForm.value.email).subscribe(
        (res) => {
          Swal.fire('', res, 'success');
        },
        (error) => {
          console.log(error);
          Swal.fire('', error.error.message, 'error');
        }
      );
    } else {
      Swal.fire(
        '',
        'Tienes que poner un correo válido para mandar el correo.',
        'warning'
      );
    }
  }

  /*isAccionSeleccionada(): boolean {
    console.log(this.contactoForm);
    console.log("ENTRO EN GENERAL", this.contactoForm.get('acciones').value);
    if (this.data.tipo === 'Crear' && this.contactoForm.get('acciones').value === '') {
      console.log("ENTRO EN NORMAL", this.contactoForm.get('acciones').value);
      return true;
    } else if (this.data.tipo === 'Crear' && this.contactoForm.get('acciones').value === '') {
      console.log("ENTRO EN ROJO", this.contactoForm.get('acciones').value);
      const accionesControl = this.contactoForm.get('acciones');
      const accionesSeleccionadas = accionesControl.value;
      return accionesSeleccionadas && accionesSeleccionadas.length > 0;
    }
    
    const accionesControl = this.contactoForm.get('acciones');
    const accionesSeleccionadas = accionesControl.value;
    
    if (!accionesSeleccionadas || accionesSeleccionadas.length === 0) {
      return false;
    }

    if (this.accionesByContacto && this.accionesByContacto.length > 0) {
      for (const accion of this.accionesByContacto) {
        if (!accionesSeleccionadas.includes(accion)) {
          return false;
        }
      }
    }
    return true;
  }*/

  /*comprobarAcciones(control: FormControl): void {
    console.log(control);
    console.log("ENTRO", this.contactoForm.get('acciones').value.length);
    if(this.contactoForm.get('acciones').value.length === 0) {
      this.rojo = true;
      console.log(this.rojo);
    } else {
      this.rojo = false;
      console.log(this.rojo);
    }
  }*/

  /*changeAcciones(acciones: any) {
    console.log('Acciones seleccionadas:', acciones);
    this.contactoForm.get('acciones').patchValue(acciones);
    console.log(this.contactoForm);
  }*/

  /*getAccionesCoincidentesText(): string {
    const accionesSeleccionadas = this.contactoForm.get('acciones').value;
    if (accionesSeleccionadas && accionesSeleccionadas.length > 0) {
      if (accionesSeleccionadas.length === 1) {
        return this.accionesList.find(accion => accion.Id === accionesSeleccionadas[0])?.Nombre || '';
      } else {
        const primerNombre = this.accionesList.find(accion => accion.Id === accionesSeleccionadas[0])?.Nombre || '';
        const cantidadRestante = accionesSeleccionadas.length - 1;
        return `${primerNombre} (+${cantidadRestante} ${cantidadRestante === 1 ? 'otro' : 'otros'})`;
      }
    }
    return '';
  }*/
}
